import React, { useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';

import useResize from "~/hooks/useResize";
import auth      from "~/services/security";

const PrivateRoute = ({ breakpoint, render, background, setBackground, expandedHeader, setExpandedHeader,  ...rest })=> {

  const [ width ] = useResize();

  useEffect(()=> {
    document.body.style.background=background;
    setBackground(background);
    setExpandedHeader(expandedHeader);
  }, []);

  useEffect(()=> {
    setExpandedHeader(width < breakpoint && expandedHeader);
  }, [width]);

  return (
    <Route {...rest} render={props => {

      const currentUser = auth.currentUserValue;

      if (!currentUser) {
        return (
          <Redirect
            to={{
              pathname : '/login',
              state    : {from: props.location},
            }} />
        );
      }

      return render({...props, expandedHeader, setExpandedHeader, breakpoint });
    }} />
  )
}

export default PrivateRoute;
